import {openPanelInModal} from "@Components/modal-container/modal-container-reducer";
import {MODALS_IDS} from "@Components/modal-container";
import type {EventOneClickPromotionPanelProps} from "@Panels/event-one-click-promotion-panel/event-one-click-promotion-panel.types";

export const openOneClickPromotionModal = (props: EventOneClickPromotionPanelProps): void => {
    window.PMW.redux.store.dispatch(
        openPanelInModal({
            modalId: MODALS_IDS.EVENT_ONE_CLICK_PROMOTION_MODAL,
            panelProps: props
        })
    );
}